var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 2H15.9998V4H15.9995V6H17.9995H19.9995H21.9995V8H19.9995V20H19.9998V22L19.9995 22H17.9995H5.99976L3.99976 22V20V8H1.99951V6H3.99976H5.99976H7.99976V4V2H9.99976H13.9995H15.9995ZM13.9995 4H9.99976V6H13.9995V4ZM13.9995 8H9.99976H7.99976L5.99976 8V20H17.9995V8L15.9995 8H13.9995ZM8.99951 10H10.9995V18H8.99951V10ZM14.9998 10H12.9998V18H14.9998V10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashM);
export default __webpack_public_path__ + "static/media/trash-m.1e9bdc3a3d05cb6767dbade83a9f952f.svg";
export { ForwardRef as ReactComponent };